



















































import { defineComponent, PropType } from '@vue/composition-api';

import AtomDivider from '@/components/atoms/AtomDivider.vue';
import WrapperCard from '@/components/atoms/WrapperCard.vue';

import type { User } from '@/modules/advisor-search/api/useUsersApi';

import AdvisorSearchUserCompany from '@/modules/advisor-search/organisms/AdvisorSearchUser/AdvisorSearchUserCompany.vue';
import AdvisorSearchUserTopic from '@/modules/advisor-search/organisms/AdvisorSearchUser/AdvisorSearchUserTopic.vue';

export default defineComponent({
  name: 'AdvisorSearchUser',
  components: {
    AtomDivider,
    WrapperCard,

    AdvisorSearchUserCompany,
    AdvisorSearchUserTopic,
  },
  props: {
    userId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    user: {
      type: Object as PropType<User>,
      required: true,
    },
  },
});
